import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/Controls'
import { CheckCircle2, Zap } from 'lucide-react'
import { DEFAULT_FREE_CREDITS } from '@/features/billing/plans'

export function PricingPreview() {
  return (
    <section className="py-24 sm:py-32 bg-ground border-t border-line relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-semibold text-ink tracking-tight mb-4">
            Pay for what you use.
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed">
            Start free, then pay based on actual tool execution and AI usage. No hidden subscription tiers.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Free Tier */}
          <div className="bg-surface border border-line rounded-2xl p-8 shadow-card flex flex-col">
            <div className="text-ink font-semibold text-xl mb-2">Starter</div>
            <div className="flex items-baseline gap-2 mb-6">
              <span className="text-4xl font-bold text-ink">$0</span>
              <span className="text-ink-muted">/ month</span>
            </div>
            
            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-start gap-3 text-ink-muted">
                <CheckCircle2 className="w-5 h-5 text-ok shrink-0" />
                <span>{DEFAULT_FREE_CREDITS} free credits on sign-up</span>
              </li>
              <li className="flex items-start gap-3 text-ink-muted">
                <CheckCircle2 className="w-5 h-5 text-ok shrink-0" />
                <span>Full GitHub integration</span>
              </li>
              <li className="flex items-start gap-3 text-ink-muted">
                <CheckCircle2 className="w-5 h-5 text-ok shrink-0" />
                <span>Approval gates & audit logs</span>
              </li>
            </ul>

            <Link to="/signin">
              <Button variant="primary" className="w-full py-3">Start free</Button>
            </Link>
          </div>

          {/* Usage Based */}
          <div className="bg-surface border border-primary/30 rounded-2xl p-8 shadow-pop flex flex-col relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-primary/10 text-primary text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider">
              Scale
            </div>
            <div className="text-ink font-semibold text-xl mb-2">Pay-as-you-go</div>
            <div className="flex items-baseline gap-2 mb-6">
              <span className="text-4xl font-bold text-ink">Usage</span>
              <span className="text-ink-muted">based</span>
            </div>
            
            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-start gap-3 text-ink-muted">
                <Zap className="w-5 h-5 text-primary shrink-0" />
                <span>Credits automatically refill when low</span>
              </li>
              <li className="flex items-start gap-3 text-ink-muted">
                <Zap className="w-5 h-5 text-primary shrink-0" />
                <span>Priced per tool call and AI token</span>
              </li>
              <li className="flex items-start gap-3 text-ink-muted">
                <Zap className="w-5 h-5 text-primary shrink-0" />
                <span>Set hard spending limits</span>
              </li>
            </ul>

            <Link to="/pricing">
              <Button className="w-full py-3 bg-ground hover:bg-raised border border-line">View full pricing</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
